<template>
    <!-- 报名信息 -->
    <div>
        <!-- v-show="$route.meta.showFather" -->
        <div class="" style="color: #000000;">
            <div class="pad-16 mb-16 box-shadow" style="color: #000000;margin-top: 16px;">
                <div class="is-flex mb-16">
                    <div class="left-icon"></div>
                    <p class="left-p">活动信息</p>
                </div>
                <div class=" ">
                    <div class="is-flex mb-16">
                        <p class="left-p " style="padding-left: 0;padding-right: 16px;">{{detail.eventName}}</p>
                        <p class="act-status" :class="detail.activityStatus==1000?'act-status-1':detail.activityStatus==2000?'act-status-2':'act-status-3'">                        {{detail.activityStatus==1000?'待开始':detail.activityStatus==2000?'进行中':'已结束'}}</p>
                    </div>
                    <div class="is-flex">
                        <div class="is-flex" style="margin-right: 3.6875rem;">
                            <p class="name-2">活动时间:</p>
                            <p class="name-3">{{utils.getNowTime(detail.startTime)}}-{{utils.getNowTime(detail.endTime)}}</p>
                        </div>
                        <div class="is-flex">
                            <p class="name-2">活动地点:</p>
                            <p class="name-3">{{detail.location}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pad-16 mb-16 box-shadow">
                <div class="is-flex mb-24">
                    <div class="left-icon"></div>
                    <p class="left-p">基本信息</p>
                </div>
                <el-form ref="form" :rules="rules" :model="form" class="boc-form" label-width="80px">
                    <el-form-item label="单位名称" prop="companyName">
                        <el-input v-model="detail.companyName" placeholder="请输入单位名称" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="detail.name" placeholder="请输入您的姓名" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="职位" prop="position">
                        <el-input v-model="detail.position" placeholder="请输入您的职位" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="contact">
                        <el-input v-model="detail.contact" placeholder="请输入您的手机号码" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="detail.email" placeholder="请输入您的邮箱" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="地址" prop="address">
                        <el-input v-model="detail.address" placeholder="请输入您的详细地址:省市区、具体街道" :disabled="disabled"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="pad-16 mb-24 box-shadow">
                <div class="is-flex mb-24">
                    <div class="left-icon"></div>
                    <p class="left-p">订单信息</p>
                </div>
                <div class="is-flex jus-bet">
                    <div class="is-flex">
                        <p class="name-2">支付金额:</p>
                        <p class="name-3">￥{{detail.payPrice}}</p>
                    </div>
                    <div class="is-flex">
                        <p class="name-2">支付时间:</p>
                        <p class="name-3">{{utils.getNowTime(detail.paymentTime)}}</p>
                    </div>
                    <div class="is-flex">
                        <p class="name-2">订单编号:</p>
                        <p class="name-3">{{detail.no}}</p>
                    </div>
                    <div></div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {
        getRegistration,
    } from '@/api/activity/api.js';
    export default {
        components: {
            
        },
        data() {
            return {
                disabled: true,
                detail:'',
            }
        },
        created() {

        },
        mounted() {
            this.getDeatils(this.$route.params.id);
        },
        methods: {
            // 报名信息
            getDeatils(id) {
                getRegistration({
                        id: id
                    }).then(res => {
                        console.log(res.data, '--')
                        this.detail = res.data;
                        if(this.num == 1){
                            this.form = res.data;
                        }else{
                            
                        }
                    })
                    .catch(error => {
            
                    });
            },
            
        }
    }
</script>


<style scoped>
    .pad-16 {
        padding: 16px;

    }

    .box-shadow {
        box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .is-flex {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }

    .hed-img {
        /*   width: 100%;
       height: auto; */
        width: 576px;
        height: 320px;
        padding-right: 32px;
    }

    .name-1 {
        font-size: 20px;
        padding-right: 9px;
    }

    .name-2 {
        color: #999999;
        font-size: 14px;
        white-space: nowrap;
        padding-right: 8px;
    }

    .name-3 {
        color: #222222;
        font-size: 14px;
        font-weight: normal;
    }


    .mb-8 {
        margin-bottom: 8px;
    }

    .mb-24 {
        margin-bottom: 24px;
    }

    .flex-tab {
        border-radius: 8px;
    }

    .flex-tab p {
        width: 25%;
        color: #666666;
        font-size: 14px;
        text-align: center;
        padding: 16px 0;
        background: #FAFAFA;
    }

    .flex-tab p:first-child {
        background: #3377FF;
        color: #FFFFFF;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    .left-icon {
        width: 6px;
        height: 20px;
        background: #3377FF;
        border-radius: 18px;
    }

    .left-p {
        font-size: 20px;
        color: #222222;
        font-weight: normal;
        padding-left: 10px;
    }

    .align-base {
        align-items: flex-start;
    }

    .baoming {
        width: 20%;
        min-width: 20%;
        text-align: center;
        padding: 12px 24px;
        background: #3377FF;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        font-weight: normal;
        color: #FFFFFF;
        white-space: nowrap;
    }


    .boc-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .boc-form .el-form-item {
        width: 40%;
        margin-bottom: 12px;
    }

    /deep/.boc-form .el-form-item__label {
        padding-right: 16px;
        color: #222222;
        font-size: 14px;
    }

    /deep/.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
        margin-right: 0;
    }

    .tishi-1 {
        color: #CCCCCC;
        font-size: 14px;
        margin-top: 12px;
    }

    .wxzf {
        width: 5.5rem;
        height: 5.5rem;
    }

    .apply p:first-child {
        color: #222222;
        font-size: 14px;
        margin-right: 1rem;
    }

    .apply p:last-child {
        color: #FF5533;
        font-size: 28px;
    }

    /deep/.el-button--primary {
        background-color: #3377FF;
        border-radius: 4px;
    }

    /deep/.el-button--primary span {
        font-size: 16px;
        color: #ffffff;
        /* padding: 0.75rem 0; */
        text-align: center;
    }

    .act-status {
        border-radius: 4px 16px 4px 16px;
        padding: 4px 16px;
        /* color: #FBB54C;
        background: #FFF6F0; */
        font-size: 14px;
        white-space: nowrap;
    }
    .act-status-1 {
        color: #FBB54C;
        background: #FFF6F0;
    }
    .act-status-2 {
        color: #3ECC64;
        background: #EBFAEF;
    }
    .act-status-3 {
        color: #FF534D;
        background: #FFF0F0;
    }

    /deep/.el-input.is-disabled .el-input__inner {
        background-color: #EFEFEF;
        color: #222222;
        font-size: 14px;

    }
</style>
